// extracted by mini-css-extract-plugin
export default {"error":"OrganizationAddUser_error_Bvjg0"};